module.exports = __webpack_public_path__ + "static/media/icon-close.c12ae116.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-close.svg
// module id = 517
// module chunks = 0